export const vacancyRequirementType = {
  optional: 2,
  mandatory: 1,
  disabled: 0
};
